module.exports = __webpack_public_path__ + "files/caf564678a3ff28efe329193e2cc6eed.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/smileys_emotion-1.png
// module id = 492
// module chunks = 76